import Backbone from '@polleverywhere/backbone'
import store from '@polleverywhere/redux'
import { slice as appSlice } from '../../slices/app'
import listenToSelector from '../../util/listen_to_selector'
import { slice as activitiesSlice } from '../../apps/activities/slice'

store.addReducers({
  [activitiesSlice.name]: activitiesSlice.reducer
})

function updateRoute () {
  const { page } = store.getState()[appSlice.name]

  if (page !== 'activities') {
    return
  }

  const routePath = activitiesSlice.selectRoutePath(store.getState())
  if (routePath) {
    this.navigate(routePath, { trigger: false, replace: false })
  }
}

/**
 * Updates URL when state changes. Also, update the state model
 * from the initial route.
 */
export default class Router extends Backbone.Router {
  get routes () {
    return {
      'activities(/:view)(?group_id=:id)': async (view, id) => {
        store.dispatch(activitiesSlice.folderUpdated({
          id: id || -1,
          name: 'Stub'
        }))

        store.dispatch(activitiesSlice.viewUpdated(view || 'activities'))
        store.dispatch(activitiesSlice.pageUpdated('activities'))
        store.dispatch(appSlice.pageUpdated('activities'))
      },
      // We need agave served under /office/index.html to direct all ALB traffic
      // from presenter.polleverywhere.com/office/index.html to singularity
      // because MSFT is very picky about domains and paths
      // Once we have phased out the web_presenter app entirely we can
      // change this around.
      'office/index.html': () => {
        store.dispatch(activitiesSlice.viewUpdated('activities'))
        store.dispatch(activitiesSlice.pageUpdated('activities'))
        store.dispatch(appSlice.pageUpdated('activities'))
      },
      ':type/:key(/:action)': async (type, key, action) => {
        const opts = { type, key }
        if (action) Object.assign(opts, { page: action })

        store.dispatch(activitiesSlice.loadActivity(opts))
        store.dispatch(appSlice.pageUpdated('activities'))
      }
    }
  }

  initialize (options = {}) {
    _.defaults(options, {
      updateURL: true
    })

    this.state = options.state
    this.appState = this.state.appStates.activities

    // Update route based on state changes
    if (!options.updateURL) {
      return
    }

    const updateRouteHandler = updateRoute.bind(this)

    // Listen to redux change
    listenToSelector((state) => state[appSlice.name].page, updateRouteHandler)
    listenToSelector(activitiesSlice.selectRoutePath, updateRouteHandler)

    // Wire up Activities state changes to the browser url
    this.listenTo(this.appState, 'change', updateRouteHandler)

    this.listenTo(this.appState, 'change:group', (state, group) => {
      // if we're viewing a group without an ID, update the path again once the id is available
      if (group && !group.has('id')) {
        this.listenToOnce(group, 'change:id', updateRouteHandler)
      }

      // Stop listening to the previous group
      const prevGroup = state.previous('group')
      if (prevGroup) {
        this.stopListening(prevGroup, 'change:id')
      }
    })

    // Update url on initial route.
    // We do this because this is the default route and we'll end up here before the router is even started.
    // Prior to backbone.history starting, `this.navigate` will not actually update the URL.
    // This ensures that the URL is properly updated if we're here before the router is started.
    this.listenToOnce(Backbone.history, 'route', updateRouteHandler)
  }
}
